module.exports = __webpack_public_path__ + "img/tk-bottom.a11a18eb.png";